import { createContext, type RefObject } from 'react'

export const DocumentSummaryContentRefContext = createContext<RefObject<HTMLDivElement> | null>(null)
